import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { BRAND } from "../lib/site";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1 pt-[140px]">{children}</main>
      <Footer />
      <a
        href={BRAND.whatsappURL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 group"
      >
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs bg-navy text-white px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Chat with an advisor
        </span>
        <span className="h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-xl shadow-emerald-900/20 hover:scale-105 transition-transform">
          <MessageCircle size={22} strokeWidth={2} />
        </span>
      </a>
    </div>
  );
};

export default Layout;
